import { createContext, useState, useCallback } from "react";
import { getAccessToken, setTokens, clearTokens } from "./tokenStorage";

export const ClinicAuthContext = createContext();

const ORG_KEY = "clinic_selected_org_id";
const ORG_NAME_KEY = "clinic_selected_org_name";

export function ClinicAuthProvider({ children }) {
  const [token, setToken] = useState(() => getAccessToken());
  const [orgId, setOrgId] = useState(() => localStorage.getItem(ORG_KEY));
  const [orgName, setOrgName] = useState(() => localStorage.getItem(ORG_NAME_KEY));

  const login = useCallback((accessToken, refreshToken) => {
    setTokens(accessToken, refreshToken);
    setToken(accessToken);
  }, []);

  const selectOrg = useCallback((id, name) => {
    localStorage.setItem(ORG_KEY, id);
    localStorage.setItem(ORG_NAME_KEY, name || "");
    setOrgId(id);
    setOrgName(name || "");
  }, []);

  const clearOrg = useCallback(() => {
    localStorage.removeItem(ORG_KEY);
    localStorage.removeItem(ORG_NAME_KEY);
    setOrgId(null);
    setOrgName(null);
  }, []);

  const logout = useCallback(() => {
    clearTokens();
    localStorage.removeItem(ORG_KEY);
    localStorage.removeItem(ORG_NAME_KEY);
    setToken(null);
    setOrgId(null);
    setOrgName(null);
  }, []);

  return (
    <ClinicAuthContext.Provider value={{ token, orgId, orgName, login, selectOrg, clearOrg, logout }}>
      {children}
    </ClinicAuthContext.Provider>
  );
}